package fr.frux.core.common.logging

/**
 * Niveau de log du bundle web (#481). Le web n'a pas de variante debug/release : un même bundle
 * sert le dev server et la production, le niveau vient donc de la page hôte.
 *
 * - [configured] : `window.fruxLogLevel`, posé par `app-config.js` (`ERROR` au déploiement,
 *   `DEBUG` par `scripts/dev-web.sh`). Une valeur inconnue compte comme absente.
 * - Sans valeur, un hôte local vaut dev (dev server lancé avant que son `app-config.js` ne porte
 *   la clé). Partout ailleurs ERROR : une page publiée n'écrit rien sous ERROR dans la console,
 *   comme une release Android ou iOS.
 */
fun webLogLevel(
    configured: String?,
    hostname: String,
): LogLevel =
    LogLevel.entries.firstOrNull { it.name == configured?.trim()?.uppercase() }
        ?: if (hostname in LOCAL_HOSTNAMES) LogLevel.DEBUG else LogLevel.ERROR

private val LOCAL_HOSTNAMES = setOf("localhost", "127.0.0.1", "[::1]", "::1")
